import { SkeletonTag } from "@/shared/ui/SkeletonItem/types";
import { TWHeight, TWWidth } from "@/styles/tw-types";
import { twCn } from "@/styles/utils";

interface Props<T extends SkeletonTag> {
  as?: T;
  width?: TWWidth;
  height?: TWHeight;
}

export function SkeletonItem<T extends SkeletonTag = "div">({
  as,
  width,
  height,
}: Props<T>) {
  const Tag = as || "div";
  return (
    <Tag
      className={twCn(
        "bg-light relative overflow-hidden rounded-md",
        width ?? "w-full",
        height ?? "h-12",
      )}
    >
      <div className="[@keyframes shimmer]:from{transform:translateX(-100%);} [@keyframes shimmer]:to{transform:translateX(100%);} absolute inset-0 -translate-x-full [animation:shimmer_1.5s_infinite_linear] bg-gradient-to-r from-transparent via-white/40 to-transparent" />
    </Tag>
  );
}
